export const FETCH_NAV_MENU_ITEMS = 'FETCH_NAV_MENU_ITEMS';
export const UPDATE_ACTIVE_NAV_MENU_ITEM_ID = 'UPDATE_ACTIVE_NAV_MENU_ITEM_ID';
export const FETCH_STORAGE_SPACE = 'FETCH_STORAGE_SPACE';
export const SETUP_ARCHIVE_PASSWORD = 'SETUP_ARCHIVE_PASSWORD';
export const RESET_ARCHIVE_PASSWORD_STATUS = 'RESET_ARCHIVE_PASSWORD_STATUS';
export const DELETE_ARCHIVE = 'DELETE_ARCHIVE';
export const RESET_ARCHIVE_DELETION_STATUS = 'RESET_ARCHIVE_DELETION_STATUS';
export const CLEANUP_ARCHIVE = 'CLEANUP_ARCHIVE';
export const RESET_CLEANUP_STATUS = 'RESET_CLEANUP_STATUS';
export const FETCH_CONTENT_ITEMS = 'FETCH_CONTENT_ITEMS';
export const SEARCH_CONTENT_ITEMS = 'SEARCH_CONTENT_ITEMS';
export const UPDATE_ACTIVE_CONTENT_TYPE = 'UPDATE_ACTIVE_CONTENT_TYPE';
export const FETCH_SHARED_CONTENT_ITEMS = 'FETCH_SHARED_CONTENT_ITEMS';
export const FETCH_USER_SUBSCRIPTION = 'FETCH_USER_SUBSCRIPTION';
export const FETCH_FILE_VERSIONS = 'FETCH_FILE_VERSIONS';
export const FETCH_FD_LINK = 'FETCH_FD_LINK';
export const SIGN_FILE = 'SIGN_FILE';
export const RESET_SIGN_FILE_STATUS = 'RESET_SIGN_FILE_STATUS';
export const CREATE_SHARED_LINK = 'CREATE_SHARED_LINK';
export const DELETE_SHARED_LINK = 'DELETE_SHARED_LINK';
export const FETCH_SHARED_LINK_SETTINGS = 'FETCH_SHARED_LINK_SETTINGS';
export const UPDATE_SHARED_LINK_SETTINGS = 'UPDATE_SHARED_LINK_SETTINGS';
export const START_CLEANUP_PROGRESS_POLLING = 'START_CLEANUP_PROGRESS_POLLING';
export const STOP_CLEANUP_PROGRESS_POLLING = 'STOP_CLEANUP_PROGRESS_POLLING';
export const FETCH_CLEANUP_STAGE = 'FETCH_CLEANUP_STAGE';
export const UPDATE_ACTIVE_VERSION_PATH = 'UPDATE_ACTIVE_VERSION_PATH';
export const UPDATE_ACTIVE_VOLUME_PATH = 'UPDATE_ACTIVE_VOLUME_PATH';
export const SORT_CONTENT_ITEMS = 'SORT_CONTENT_ITEMS';
export const SORT_SHARED_CONTENT_ITEMS = 'SORT_SHARED_CONTENT_ITEMS';
